<div>
  @if (!isComplete) {
    <nz-tabs [nzTabBarExtraContent]="extraTemplate" [(nzSelectedIndex)]="tabIndex">
      <nz-tab nzTitle="新建班级">
        <div class="form-box">
          <form nz-form nzLayout="vertical">
            <nz-form-item>
              <nz-form-label nzFor="className">名称</nz-form-label>
              <nz-form-control>
                <input nz-input name="name" required id="className" [(ngModel)]="targetClassName" />
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-label nzFor="description">目标</nz-form-label>
              <nz-form-control>
                <textarea
                  name="description"
                  nz-input
                  rows="3"
                  id="id-description"
                  [(ngModel)]="targetClassDescription"
                ></textarea>
              </nz-form-control>
            </nz-form-item>
            <div nz-row>
              <div nz-col class="mr-lg">
                <nz-form-item>
                  <nz-form-control>
                    <label nz-checkbox [(ngModel)]="autoDestroy" [ngModelOptions]="{ standalone: true }"
                      >发布任务后解散</label
                    >
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col>
                <nz-form-item>
                  <nz-form-control>
                    <label nz-checkbox [(ngModel)]="enableTeacherAutoJoin" [ngModelOptions]="{ standalone: true }"
                      >加入学生任课老师</label
                    >
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>
            <nz-form-item>
              <nz-form-label [nzSpan]="5">选中的学生</nz-form-label>
              <nz-form-control nzSpan="24">
                @for (item of users; track item; let index = $index) {
                  <nz-tag nzMode="closeable" class="mb-md mr-md" (nzOnClose)="onRemoveUser(index)">{{
                    item.firstName
                  }}</nz-tag>
                }
              </nz-form-control>
            </nz-form-item>
          </form>
        </div>
      </nz-tab>
      <nz-tab nzTitle="加入已有" [nzDisabled]="$safeNavigationMigration(classroomList?.length) <= 0">
        <div class="form-box">
          <form nz-form nzLayout="vertical">
            <nz-form-item style="margin-bottom: 0">
              <nz-form-control nzSpan="24">
                <div nz-row [nzGutter]="16" class="mt-sm">
                  @if (classroomList?.length > 0) {
                    @for (classroom of classroomList; track classroom) {
                      <fl-target-chose-class-item
                        nz-col
                        nzSpan="6"
                        nz-tooltip
                        [nzTooltipTitle]="classroom.name"
                        nzTooltipPlacement="top"
                        [label]="classroom.name"
                        [value]="classroom.id"
                        [(checked)]="classroom.checked"
                        (onChange)="onClassroomChange(classroom)"
                      ></fl-target-chose-class-item>
                    }
                  }
                  <div nz-row nzJustify="center" style="width: 100%">
                    @if (classroomList?.length <= 0) {
                      <nz-empty nzNotFoundImage="simple"></nz-empty>
                    }
                  </div>
                </div>
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-label [nzSpan]="5">选中的学生</nz-form-label>
              <nz-form-control nzSpan="24">
                @for (item of users; track item; let index = $index) {
                  <nz-tag nzMode="closeable" class="mb-md mr-md" (nzOnClose)="onRemoveUser(index)">{{
                    item.firstName
                  }}</nz-tag>
                }
              </nz-form-control>
            </nz-form-item>
          </form>
        </div>
      </nz-tab>
    </nz-tabs>
    <!--底部-->
    <div class="footer px-md" nz-row nzJustify="space-between" nzAlign="middle">
      <ng-container>
        <div>已选：{{ users.length }}人</div>
        <div>
          <button class="mr-md" nz-button (click)="close(TargetCloseEnum.CLOSE)" [nzLoading]="isSubmitting">
            取消
          </button>
          <button class="mr-md" nz-button nzType="primary" (click)="submit()" [nzLoading]="isSubmitting">确认</button>
        </div>
      </ng-container>
    </div>
  }

  @if (isComplete) {
    <div class="header-box" nz-row nzJustify="space-between">
      <p class="weight-font">靶向班</p>
      <i class="point" (click)="close(TargetCloseEnum.CLOSE)" nz-icon nzType="close" nzTheme="outline"></i>
    </div>
    <div class="success">
      <nz-result nzStatus="success" nzTitle="创建成功" [nzSubTitle]="resultSubTitle">
        <div nz-result-extra>
          <button flCheckLoginType nz-button nzType="default" (click)="navToUrl('material')">推送资料</button>
          <button nz-button nzType="default" (click)="navToUrl('tk')">推送题目</button>
          <button nz-button nzType="default" (click)="navToUrl('course')">推送课程</button>
          <button nz-button nzType="primary" (click)="close(TargetCloseEnum.FINISH)">完成</button>
        </div>
      </nz-result>
    </div>
  }
</div>

<ng-template #resultSubTitle>
  <div nz-row nzJustify="center">
    <span>可去<a href="javascript:0" (click)="navToUrl('class')">我的班级</a>添加其他教师</span>
  </div>
</ng-template>

<ng-template #extraTemplate>
  <i class="point" (click)="close(TargetCloseEnum.CLOSE)" nz-icon nzType="close" nzTheme="outline"></i>
</ng-template>
